module.exports = __webpack_public_path__ + "img/product-1.d91c2915.jpg";